module.exports = "/_next/static/images/ryuunoko_payment-3b6bc17486b00793e7cb0f2062fa6f0d.jpg";